/*LIBRARY*/
import { useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { Map } from "maplibre-gl";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "maplibre-gl-draw/dist/mapbox-gl-draw.css";

/*COMPONENT*/
import MAP_CONTROL_DRAW from "../libre_draw/MAP_CONTROL_DRAW";
import MAP_CONTROL_BASIC from "../libre_draw/MAP_CONTROL_BASIC";
import DRAW_GEO from "../libre_draw/DRAW_GEO";
import LEGEND_PARENT from "../map_legend/LEGEND_PARENT";
import POPUP_EDITOR from "../libre_popup/POPUP_EDITOR";
import LAYER_FEATURE_SELECTED from "./LAYER_FEATURE_SELECTED";
import LAYER_GEO from "./LAYER_GEO";
import MARKER_GEO from "./MARKER_GEO";
import LAYER_HEATMAP from "./LAYER_HEATMAP";
import LAYER_GPS from "./LAYER_GPS";
import LAYER_TOOLBOX from "./LAYER_TOOLBOX";
import LAYER_INSIGHT from "./LAYER_INSIGHT";
import SYMBOL_GEO from "./SYMBOL_GEO";
import M_S_LOADING from "../libre_marker_sini/M_S_LOADING";
import LAYER_S_CENTER from "../libre_layer_sini/LAYER_S_CENTER";
import LAYER_S_POI from "../libre_layer_sini/LAYER_S_POI";
import LAYER_S_POI_SURVEY_1 from "../libre_layer_sini/LAYER_S_POI_SURVEY_1";
import LAYER_S_DEMOGRAPHY_LIST from "../libre_layer_sini/LAYER_S_DEMOGRAPHY_LIST";
import LAYER_S_ISOCHRONE from "../libre_layer_sini/LAYER_S_ISOCHRONE";
import LAYER_S_FLOOD_NEIGHBOR from "../libre_layer_sini/LAYER_S_FLOOD_NEIGHBOR";
import LAYER_S_LANDSLIDE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDSLIDE_NEIGHBOR";
import LAYER_S_LANDVALUE from "../libre_layer_sini/LAYER_S_LANDVALUE";
import LAYER_S_LANDVALUE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDVALUE_NEIGHBOR";
import LAYER_S_LANDZONE_NEIGHBOR from "../libre_layer_sini/LAYER_S_LANDZONE_NEIGHBOR";
import LAYER_S_LANDZONE from "../libre_layer_sini/LAYER_S_LANDZONE";
import LAYER_S_RDTR_NEIGHBOR from "../libre_layer_sini/LAYER_S_RDTR_NEIGHBOR";
import LAYER_S_RDTR_ONE from "../libre_layer_sini/LAYER_S_RDTR_ONE";
import LAYER_S_TSUNAMI_NEIGHBOR from "../libre_layer_sini/LAYER_S_TSUNAMI_NEIGHBOR";
import LAYER_S_POI_PROPERTY from "../libre_layer_sini/LAYER_S_POI_PROPERTY";
import LAYER_SEARCH from "./LAYER_SEARCH";
import LAYER_TOOLBOX_GRID from "./LAYER_TOOLBOX_GRID";

//banjir algoritma
import LAYER_FLOOD_SERVER from "./LAYER_FLOOD_SERVER";
import LAYER_EXTRUDE_DEM from "./LAYER_EXTRUDE_DEM";
import LAYER_EXTRUDE_FLOOD from "./LAYER_EXTRUDE_FLOOD";
import FLOOD_NEW from "../sidebar_map_right/FLOOD_NEW";

//testing
import A_ARROW_PERPENDICULAR from "../layer_anotation/A_ARROW_PERPENDICULAR";
import LIBRE_GLB_BOGOR from "./LIBRE_GLB_BOGOR";
import LIBRE_GLB_TASIK from "./LIBRE_GLB_TASIK";
import LAYER_AI from "./LAYER_AI";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_sini } from "../../App/actions/sini_v2";
import { get_features_by_bound } from "../../App/actions/get_features_by_bound";

import get_url_query from "../../App/validation/get_url_query";

/*CONST*/
const basemap_url = process.env.REACT_APP_MAPID_BASEMAP;
const basemap_key = process.env.REACT_APP_BASEMAP_KEY;
const max_zoom = 10;
const delay_bounding_box = 500;

const MAP_COMPONENT = ({
  auth,
  layer,
  project,
  properties,
  is_editable,
  set_value_layer,
  set_value_sini,
  get_features_by_bound,
}) => {
  const fetch_timeout = useRef(null);

  const { map_object } = layer;

  // const { mode_map } = properties;

  // on_get_features_by_bound is wrapped in useCallback to prevent re-creation on every render,
  // unless its dependencies (props) change.
  const on_get_features_by_bound = useCallback(() => {
    const { map_object, layer_id_bound, geo_layer_list } = layer;
    if (map_object && layer_id_bound?.length > 0) {
      const zoom_level = map_object.getZoom();
      if (zoom_level >= max_zoom) {
        const { geo_project } = project;
        const geo_layer = geo_layer_list.find(
          (item) => item?.geo_layer?._id === layer_id_bound[0]
        );
        const fields = geo_layer?.geo_layer?.fields || [];
        const bounds = map_object.getBounds();
        const params = {
          bounds,
          geo_layer_id: layer_id_bound[0],
          geo_project_id: geo_project._id,
          fields: fields,
        };
        get_features_by_bound(params);
      }
    }
  }, [layer, project, get_features_by_bound]);

  // This effect handles the one-time initialization of the map.
  useEffect(() => {
    const map_object = new Map({
      container: "map_object",
      style: `${basemap_url}/styles/street-2d-building/style.json?key=${basemap_key}`,
      center: [118.72762419354456, -0.2055368192132505],
      zoom: 3.7,
      maxPitch: 60,
      attributionControl: false,
      canvasContextAttributes: { antialias: true }, // create the gl context with MSAA antialiasing, so custom layers are antialiased
    });

    map_object.addControl(
      new maplibregl.AttributionControl({
        customAttribution: `GEO V ${auth.version}`,
        compact: properties.is_mobile,
      }),
      "bottom-left"
    );

    map_object.addControl(
      new maplibregl.ScaleControl({
        maxWidth: 100,
        unit: "metric",
      }),
      "bottom-right"
    );

    set_value_layer({
      key: "map_object",
      value: map_object,
    });

    // This is the cleanup function that will be called when the component unmounts.
    return () => {
      // Clear redux state related to this component
      set_value_layer({ key: "map_object", value: null });
      set_value_sini({ key: "sini_v2_list", value: [] });
      set_value_sini({ key: "ai_parent_detail_list", value: [] });
      set_value_sini({ key: "ai_parent_list", value: [] });
      // Properly remove the map instance
      if (map_object) {
        map_object.remove();
      }
    };
    // These dependencies ensure this effect runs only when these stable values change.
    // In practice, this will run once on mount.
  }, [auth.version, set_value_layer, set_value_sini, properties.is_mobile]);

  // This effect sets up map event listeners.
  // It re-runs if the map object becomes available or if the function to call changes.
  useEffect(() => {
    const map_object = layer.map_object;
    if (!map_object) {
      return;
    }

    const setup_map_listeners = (map_instance) => {
      const zoomHandler = () => {
        const zoom_level = map_instance.getZoom();
        // Always clean up move listeners on zoom to avoid duplicates
        map_instance.off("move");
        map_instance.off("moveend");

        if (zoom_level < max_zoom) {
          // Listeners are already off, do nothing.
        } else {
          // If zoom is high enough, re-attach move listeners
          map_instance.on("move", () => {
            clearTimeout(fetch_timeout.current);
          });
          map_instance.on("moveend", () => {
            clearTimeout(fetch_timeout.current);
            fetch_timeout.current = setTimeout(() => {
              if (map_instance.getZoom() >= max_zoom) {
                on_get_features_by_bound();
              }
            }, delay_bounding_box);
          });
        }
      };

      map_instance.on("zoom", zoomHandler);
      // Initial call to set state correctly based on initial zoom
      zoomHandler();

      // Return a cleanup function to remove the listeners
      return () => {
        if (map_instance.isStyleLoaded()) {
          map_instance.off("zoom", zoomHandler);
          map_instance.off("move");
          map_instance.off("moveend");
        }
      };
    };

    const cleanup_listeners = setup_map_listeners(map_object);

    return cleanup_listeners;
  }, [layer.map_object, on_get_features_by_bound]);

  const {
    latitude_selected,
    longitude_selected,
    fields_selected,
    properties_selected,
    type_2_selected,
    feature_key_selected,
    geo_layer_selected,
    genangan_cm_selected,
  } = layer;

  const { projection, legend_status } = properties;

  const mode = get_url_query("mode");

  return (
    <>
      <main
        id="map_object"
        style={{
          backgroundColor: projection === "globe" ? "#000" : "#efefef",
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      />
      <MAP_CONTROL_DRAW />
      <MAP_CONTROL_BASIC />
      <DRAW_GEO />

      {map_object && (
        <>
          <MARKER_GEO />
          <SYMBOL_GEO />
          <LAYER_GEO />
          <LAYER_HEATMAP />
          <LAYER_TOOLBOX />
          <LAYER_GPS />
          <LAYER_INSIGHT />
          <M_S_LOADING />
          <LAYER_S_CENTER />
          <LAYER_S_POI />
          <LAYER_S_POI_PROPERTY />
          <LAYER_S_ISOCHRONE />
          <LAYER_S_DEMOGRAPHY_LIST />
          <LAYER_S_LANDVALUE />
          <LAYER_S_LANDVALUE_NEIGHBOR />
          <LAYER_S_LANDZONE />
          <LAYER_S_LANDZONE_NEIGHBOR />
          <LAYER_S_RDTR_ONE />
          <LAYER_S_RDTR_NEIGHBOR />
          <LAYER_S_POI_SURVEY_1 />
          <LAYER_S_FLOOD_NEIGHBOR />
          <LAYER_S_LANDSLIDE_NEIGHBOR />
          <LAYER_S_TSUNAMI_NEIGHBOR />
          <LAYER_FEATURE_SELECTED />
          <LAYER_TOOLBOX_GRID />
          {legend_status && <LEGEND_PARENT />}
          <POPUP_EDITOR
            latitude_selected={latitude_selected}
            longitude_selected={longitude_selected}
            fields_selected={fields_selected}
            properties_selected={properties_selected}
            type_2_selected={type_2_selected}
            feature_key_selected={feature_key_selected}
            genangan_cm_selected={genangan_cm_selected}
            geo_layer_selected={geo_layer_selected}
            is_editable={is_editable}
          />

          <LAYER_SEARCH />
          <LAYER_AI />

          <LAYER_FLOOD_SERVER />
          <LAYER_EXTRUDE_DEM />
          <LAYER_EXTRUDE_FLOOD />
          <FLOOD_NEW />

          {mode === "stasiun_tasik" && <LIBRE_GLB_TASIK />}
          {mode === "stasiun_bogor" && <LIBRE_GLB_BOGOR />}
          {mode === "poc_anotation" && (
            <>
              <A_ARROW_PERPENDICULAR
                title="Papua-Maluku"
                desc="🗿✨ Kepulauan Papua-Maluku: 🏞️ Tanah emas dan rempah-rempah! Papua adalah rumah bagi Burung Cenderawasih 🦜 (burung surga) dan suku yang tinggal di rumah pohon tertinggi, sementara Maluku adalah mutiara yang aroma cengkeh 🌰 dan palanya memicu penjelajahan dunia. Masyarakatnya adalah penjaga tradisi Melanesia dengan seni ukir yang magis 🎨.
      "
                long_1={138.43197613779597}
                lat_1={-3.8852836878900945}
                long_2={147.59887262481573}
                lat_2={0.5763802396343749}
                corner_mode="horizontal-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />

              <A_ARROW_PERPENDICULAR
                title="Pulau Kalimantan"
                desc="🐒🌿 Pulau Kalimantan: 🌳 Si raksasa hijau yang dilintasi Pulau Seribu Sungai! Dikenal sebagai paru-paru dunia 🌬️ (sebelum banyak yang hilang), dihuni oleh Suku Dayak yang gagah berani dengan tradisi tato 🖊️ dan rumah panjang yang mistis, serta menjadi tempat tinggal bagi Orangutan 🧡.
      "
                long_1={114.20708834547031}
                lat_1={-0.46812399284432615}
                long_2={109.0722249376912}
                lat_2={6.500845904513838}
                corner_mode="horizontal-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />

              <A_ARROW_PERPENDICULAR
                title="Pulau Sumatera"
                desc="🌶️🏠 Pulau Sumatera: 🌋 Jalur sutra maritim kuno! Pulau ini adalah tempat Suku Minangkabau mengukuhkan matriarki (garis keturunan ibu) 👑 sambil terus merantau menyebarkan masakan Rendang 🍛 yang legendaris, dan Suku Batak yang lantang suaranya menjunjung marga dengan adat yang sangat meriah di tepi Danau Toba 🏞️.
      "
                long_1={102.11877164191714}
                lat_1={-0.8925994350754394}
                long_2={93.02190349408988}
                lat_2={-7.198241827232351}
                corner_mode="vertical-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />

              <A_ARROW_PERPENDICULAR
                title="Pulau Sulawesi"
                desc="⛵⚰️ Pulau Sulawesi: 🗺️ Si K unik dengan para pelaut ulung! Dihuni oleh Suku Bugis dan Makassar yang memiliki filosofi Phinisi ⚓ untuk mengarungi tujuh samudra, sementara di pegunungan, Suku Toraja merayakan kehidupan dengan upacara kematian yang paling mewah 🐃 dan artistik di dunia.
      "
                long_1={120.43195741498533}
                lat_1={-2.1556015365210754}
                long_2={131.5751864461028}
                lat_2={5.585272146173068}
                corner_mode="horizontal-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />

              <A_ARROW_PERPENDICULAR
                title="Jawa-Bali"
                desc="🧘‍♀️🍚 Kepulauan Jawa-Bali: 🏙️ Pusat peradaban padat dan surganya dewa-dewi! Jawa adalah dapur dan panggung politik negara yang penduduknya terkenal dengan seni batik 👘, wayang 🎭, dan falsafah hidup yang halus. Sementara Bali adalah pulau kecil yang seluruh hidupnya didedikasikan pada ritual Hindu, menjadikannya perwujudan Taman Firdaus 🌴 di mata dunia.
      "
                long_1={111.67228285030262}
                lat_1={-7.672020477470284}
                long_2={106.90346493967053}
                lat_2={-14.85154483700812}
                corner_mode="vertical-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />

              <A_ARROW_PERPENDICULAR
                title="Pulau Timor"
                desc="🐐🧵 Pulau Timor: ☀️ Gerbang timur yang kering, keras, namun kaya budaya! Merupakan tanah para penggembala yang gigih, terkenal dengan kain Tenun Ikat yang motifnya bercerita 🖼️ tentang alam dan leluhur, serta memiliki tradisi belis (mahar) yang sangat unik dan berharga 💍."
                long_1={124.3643292321479}
                lat_1={-9.758754327821961}
                long_2={129.66016266706106}
                lat_2={-18.008676973060474}
                corner_mode="vertical-first"
                start_arrow_style="triangle"
                end_arrow_style="none"
                long_width={12}
                lat_width={11.5}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_sini,
  get_features_by_bound,
})(MAP_COMPONENT);
